   window.theme = window.theme || {};
  theme.config = {
    mqlSmall: false,
    mediaQuerySmall: 'screen and (max-width: 749px)',
    isTouch:
      'ontouchstart' in window ||
      (window.DocumentTouch && window.document instanceof DocumentTouch) ||
      window.navigator.maxTouchPoints ||
      window.navigator.msMaxTouchPoints
        ? true
        : false,
    rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false,
  };
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    } else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  };
  function MarqueeMain() {
    class MarqueeBar extends HTMLElement {
      constructor() {
        super();

        this.config = {
          autorotate: this.dataset.autorotate === 'true',
          autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000,
          moveTime: parseFloat(this.dataset.speed), // 100px going to move for
          space: 100, // 100px
        };

        this.initOnDesktop();

        document.addEventListener('matchSmall', () => {
          this.unload();
          this.initOnMobile();
        });

        document.addEventListener('unmatchSmall', () => {
          this.unload();
          this.initOnDesktop();
        });
      }

      initOnDesktop() {
        switch (this.dataset.layout) {
          case 'marquee':
            this.initMarquee();
            break;

          default:
            this.initMarqueeOptimized();
        }
      }

      initOnMobile() {
        switch (this.dataset.mobileLayout) {
          case 'marquee':
            this.initMarquee();
            break;
        }
      }

      unload() {
        if (this.classList.contains('marquee')) {
          this.classList.remove('marquee');
          this.querySelectorAll('.marquee-slider[aria-hidden]').forEach((slider) => {
            slider.remove();
          });
        }

        if (this.observer && typeof this.observer.unobserve === 'function') {
          this.observer.unobserve(this);
        }
      }

      initMarqueeOptimized() {
        setTimeout(() => {
          this.marqueeAnimation();
        });

        // pause when out of view
        this.observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.isAnimated && this.classList.remove('marquee--paused');
              } else {
                this.isAnimated && this.classList.add('marquee--paused');
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        this.observer.observe(this);

        window.addEventListener('resize', this.marqueeAnimation.bind(this));
      }

      marqueeAnimation() {
        const slider = this.querySelector('.marquee-slider');

        if (slider.scrollWidth > this.clientWidth) {
          if (!this.isAnimated) {
            for (let index = 0; index < 2; index++) {
              const clone = slider.cloneNode(true);
              clone.setAttribute('aria-hidden', true);
              this.appendChild(clone);
            }

            this.classList.add('marquee');
            this.style.setProperty('--duration', `${(slider.scrollWidth / this.config.space) * this.config.moveTime}s`);
            this.isAnimated = true;
          }
        } else if (this.isAnimated) {
          for (let index = 0; index < 2; index++) {
            this.removeChild(this.lastElementChild);
          }
          this.classList.remove('marquee');
          this.isAnimated = false;
        }
      }

      initMarquee() {
        setTimeout(() => {
          const slider = this.querySelector('.marquee-slider');

          for (let index = 0; index < 10; index++) {
            const clone = slider.cloneNode(true);
            clone.setAttribute('aria-hidden', true);
            this.appendChild(clone);
          }

          this.classList.add('marquee');
          this.style.setProperty('--duration', `${(slider.clientWidth / this.config.space) * this.config.moveTime}s`);
        });
        
        setTimeout(() => {
          const slider = this.querySelector('.announcement-slider');
          for (let index = 0; index < 10; index++) {
            const clone = slider.cloneNode(true);
            clone.setAttribute('aria-hidden', true);
            this.appendChild(clone);
          }

          this.classList.add('marquee');
          this.style.setProperty('--duration', `${(slider.clientWidth / this.config.space) * this.config.moveTime}s`);
        });

        // pause when out of view
        this.observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.remove('marquee--paused');
              } else {
                this.classList.add('marquee--paused');
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        this.observer.observe(this);
      }
    }
    customElements.define('marquee-slider-main', MarqueeBar);
  }
  MarqueeMain();




// Customizo Product

$('.custom-cuss-button').click(function (e) {
  e.preventDefault();
        $('.js-section__home-product-2 .shopify-block.shopify-app-block button').click()
})
